<template>
  <div>
    <Head title="Inventaris - Asset Group" />
    <h1 class="mb-8 text-3xl font-bold">
      Inventaris
      <span class="text-indigo-400 font-medium"> / </span>
      Asset Group
    </h1>
    <div class="sectors-center flex justify-between mb-6">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
        :show-dropdown="false" />
      <Link class="btn-indigo" href="/asset_groups/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Asset Group</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Group Name
            </th>
            <th class="pb-4 pt-6 px-6">
              Descriptions
            </th>
            <th class="pb-4 pt-6 px-4">
              Location
            </th>
            <th class="pb-4 pt-6 px-4" colspan="2">
              Last Updated
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="group in assetGroups.data"
            :key="group.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/asset_groups/${group.id}/edit`"
                tabindex="-1">
                {{ group.name }}
              </Link>
            </td>
            <td class="whitespace-normal border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/asset_groups/${group.id}/edit`"
                tabindex="-1">
                {{ group.description }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/asset_groups/${group.id}/edit`"
                tabindex="-1">
                {{ group.location_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/asset_groups/${group.id}/edit`"
                tabindex="-1">
                {{ group.updated_at }}
              </Link>
            </td>
          </tr>
          <tr v-if="assetGroups.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">
              No Group found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="assetGroups.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue'

export default {
    layout: Layout,
}
</script>

<script setup>
import { ref, watch, defineProps } from 'vue'
import { Head, Link, router } from '@inertiajs/vue3'
import Pagination from '@/Shared/Pagination.vue'
import SearchFilter from '@/Shared/SearchFilter.vue'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'

const props = defineProps({
    filters: Object,
    assetGroups: Object,
})

const form = ref({
    search: props.filters.search,
    trashed: props.filters.trashed,
})

const reset = () => {
    form.value = mapValues(form.value, () => null)
}

const throttleWatch = throttle(() => {
    router.get('/asset_groups', pickBy(form.value), { preserveState: true })
}, 350)

watch(form, throttleWatch, { deep: true })
</script>
